import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { ServiceActionDetails, ServiceActions } from "../types/service";
import customFetch from "../utils/customFetch";

export const useGetAllServices = () => {
  return useQuery<{ service: string, actions: { name: string, type: number }[] }[], ErrorEvent>({
    queryKey: ['allServices'],
    queryFn: () => {
      return customFetch(`/v1/externalServices`)
        .then(async(res) => {
          const data = await res.json();
          return res.ok
            ? data
            : Promise.reject(new Error('Failed to get services'))
        })
        .catch((err) => toast.error(err.message));
    }
  });
}

export const useGetActionsForService = () => {
  return useMutation<ServiceActions, ErrorEvent, { service: string }>({
    mutationFn: ({ service }) => {
      return customFetch(`/v1/externalServices/${service}/actions`)
        .then(async(res) => {
          const data = await res.json();
          return res.ok
            ? data
            : Promise.reject(new Error(`Failed to fetch service actions for ${service}`))
        })
        .catch((err) => toast.error(err.message));
    }
  });
}
